/* 🤖 this file was generated by svg-to-ts */
export const DfIconEpisode16: {
  name: 'episode-16';
  data: string;
} = {
  name: 'episode-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m3 6 3.254-3.65A1 1 0 0 1 8 3.016v9.999a1 1 0 0 1-1.75.662L3 10H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1zm6 0a2 2 0 1 1 0 4V6zm1-4c3.002 0 5 3.034 5 6 0 2.967-2 6-5 6a1 1 0 1 1 0-2c2.002 0 3-2.142 3-4 0-1.833-1-4-3-4a1 1 0 0 1 0-2z"/></svg>`
};
